var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticStyle:{"height":"40px","line-height":"40px"}},[_vm._v(_vm._s(_vm.title))])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }